var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Who Pays Title?"}},[_c('input-checkbox',{attrs:{"name":"buyer_pays_title","label":"Buyer","value":_vm.deal.buyer_pays_title,"read_only":_vm.read_only}}),_vm._v(" "),_c('input-checkbox',{attrs:{"name":"seller_pays_title","label":"Seller","value":_vm.deal.seller_pays_title,"read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }